'use client';

import { Button } from "@/components/ui/Button";
import { SchoolData } from "./SchoolsPage";
import { BookmarkSquareIcon } from "@heroicons/react/24/outline";
import { PressEvent } from "@react-types/shared/src/events";

export function BookButton({ schoolName, cityName, label }: { schoolName: string, cityName: string, label: string }) {
    const handleBookSchoolClick = (e: PressEvent) => {
        window.open(`https://www.google.com/search?q=classes schedule and booking for ${schoolName} school in ${cityName}`, '_blank');
    };

    return <Button variant="ghost" color="primary" size="sm" className="min-w-32" startContent={<BookmarkSquareIcon className="w-4 h-4" />} onPress={handleBookSchoolClick}>                
        {label}
    </Button>;
}